import React, { useEffect, useState } from "react";
import { Eye, Send } from "lucide-react";
import { api } from "@/lib/api";
import { Panel } from "@/components/portal/crm/kit";
import { ukDayTime } from "@/lib/time";
import "@/styles/deal-pitch.css";

const times = (n) => (n === 1 ? "once" : n === 2 ? "twice" : `${n} times`);

/** What this desk has emailed on the case, and who has opened it — every email carries a tracked link. */
export function SentLog({ leadId, tick = 0, broker, testId = "lender-sent-log" }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/lender/leads/${leadId}/sends`).then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, [leadId, tick]);
  if (!items.length) return null;
  return (
    <Panel title="Sent from your desk" testId={testId}
           sub={`Each email carries a tracked link, so you can see when ${broker ? "your lenders" : "your credit team"} open it.`}>
      <ul className="dp-log">
        {items.map((s) => (
          <li key={s.id} data-testid={`${testId}-${s.id}`}>
            <span className="ic mail"><Send className="size-4" /></span>
            <span style={{ minWidth: 0, flex: 1 }}>
              <b>{s.doc === "deal_pack" ? "Deal pack" : "Company check"}</b>
              <small>Sent {ukDayTime(s.at)}{s.via === "link" ? " as a link" : " · PDF attached"}</small>
              <span className="dp-recips">
                {s.recipients.map((r) => (
                  <span key={r.email} className={`dp-recip${r.opens ? " on" : ""}`} data-testid={`${testId}-${s.id}-${r.email}`}>
                    {r.opens ? <Eye className="size-3.5" /> : null}
                    <span>{r.email}</span>
                    <em>{r.opens ? `Opened ${times(r.opens)} · last ${ukDayTime(r.last_opened_at)}` : "Not opened yet"}</em>
                  </span>
                ))}
              </span>
            </span>
          </li>
        ))}
      </ul>
    </Panel>
  );
}
